/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserdata = `mutation CreateUserdata($input: CreateUserdataInput!) {
  createUserdata(input: $input) {
    id
    fullname
    avv_link
    avv_version
    avv_signature
    avv_signed_date
    createdAt
    updatedAt
  }
}
`;
export const updateUserdata = `mutation UpdateUserdata($input: UpdateUserdataInput!) {
  updateUserdata(input: $input) {
    id
    fullname
    avv_link
    avv_version
    avv_signature
    avv_signed_date
    createdAt
    updatedAt
  }
}
`;
export const deleteUserdata = `mutation DeleteUserdata($input: DeleteUserdataInput!) {
  deleteUserdata(input: $input) {
    id
    fullname
    avv_link
    avv_version
    avv_signature
    avv_signed_date
    createdAt
    updatedAt
  }
}
`;
export const createCompany = `mutation CreateCompany($input: CreateCompanyInput!) {
  createCompany(input: $input) {
    id
    name
    fullname
    address_street
    address_street_no
    address_zip
    address_city
    address_country
    responsible_name
    responsible_role
    processes {
      nextToken
    }
    measureSets {
      nextToken
    }
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
export const updateCompany = `mutation UpdateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    id
    name
    fullname
    address_street
    address_street_no
    address_zip
    address_city
    address_country
    responsible_name
    responsible_role
    processes {
      nextToken
    }
    measureSets {
      nextToken
    }
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
export const deleteCompany = `mutation DeleteCompany($input: DeleteCompanyInput!) {
  deleteCompany(input: $input) {
    id
    name
    fullname
    address_street
    address_street_no
    address_zip
    address_city
    address_country
    responsible_name
    responsible_role
    processes {
      nextToken
    }
    measureSets {
      nextToken
    }
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
export const createMeasureSetMeasure = `mutation CreateMeasureSetMeasure($input: CreateMeasureSetMeasureInput!) {
  createMeasureSetMeasure(input: $input) {
    id
    label
    description
    measureSet {
      id
      type
      label
      seq_nr
      description
      commentatory
      status
      createdAt
      updatedAt
    }
    status
    createdAt
    updatedAt
  }
}
`;
export const updateMeasureSetMeasure = `mutation UpdateMeasureSetMeasure($input: UpdateMeasureSetMeasureInput!) {
  updateMeasureSetMeasure(input: $input) {
    id
    label
    description
    measureSet {
      id
      type
      label
      seq_nr
      description
      commentatory
      status
      createdAt
      updatedAt
    }
    status
    createdAt
    updatedAt
  }
}
`;
export const deleteMeasureSetMeasure = `mutation DeleteMeasureSetMeasure($input: DeleteMeasureSetMeasureInput!) {
  deleteMeasureSetMeasure(input: $input) {
    id
    label
    description
    measureSet {
      id
      type
      label
      seq_nr
      description
      commentatory
      status
      createdAt
      updatedAt
    }
    status
    createdAt
    updatedAt
  }
}
`;
export const createProcessMeasure = `mutation CreateProcessMeasure($input: CreateProcessMeasureInput!) {
  createProcessMeasure(input: $input) {
    id
    auto_managed
    label
    description
    process {
      id
      text_header
      seq_nr
      status
      text_legal
      legal_basis
      text_problem
      damage_scenario
      risk_probability
      data_category
      victim_risk
      damage_rate
      dept_resp
      recipient_category
      delete_period
      assessment_necessary
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    status
    createdAt
    updatedAt
  }
}
`;
export const updateProcessMeasure = `mutation UpdateProcessMeasure($input: UpdateProcessMeasureInput!) {
  updateProcessMeasure(input: $input) {
    id
    auto_managed
    label
    description
    process {
      id
      text_header
      seq_nr
      status
      text_legal
      legal_basis
      text_problem
      damage_scenario
      risk_probability
      data_category
      victim_risk
      damage_rate
      dept_resp
      recipient_category
      delete_period
      assessment_necessary
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    status
    createdAt
    updatedAt
  }
}
`;
export const deleteProcessMeasure = `mutation DeleteProcessMeasure($input: DeleteProcessMeasureInput!) {
  deleteProcessMeasure(input: $input) {
    id
    auto_managed
    label
    description
    process {
      id
      text_header
      seq_nr
      status
      text_legal
      legal_basis
      text_problem
      damage_scenario
      risk_probability
      data_category
      victim_risk
      damage_rate
      dept_resp
      recipient_category
      delete_period
      assessment_necessary
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    status
    createdAt
    updatedAt
  }
}
`;
export const createMeasureSet = `mutation CreateMeasureSet($input: CreateMeasureSetInput!) {
  createMeasureSet(input: $input) {
    id
    company {
      id
      name
      fullname
      address_street
      address_street_no
      address_zip
      address_city
      address_country
      responsible_name
      responsible_role
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    type
    label
    seq_nr
    description
    processes {
      nextToken
    }
    measures {
      nextToken
    }
    commentatory
    status
    createdAt
    updatedAt
  }
}
`;
export const updateMeasureSet = `mutation UpdateMeasureSet($input: UpdateMeasureSetInput!) {
  updateMeasureSet(input: $input) {
    id
    company {
      id
      name
      fullname
      address_street
      address_street_no
      address_zip
      address_city
      address_country
      responsible_name
      responsible_role
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    type
    label
    seq_nr
    description
    processes {
      nextToken
    }
    measures {
      nextToken
    }
    commentatory
    status
    createdAt
    updatedAt
  }
}
`;
export const deleteMeasureSet = `mutation DeleteMeasureSet($input: DeleteMeasureSetInput!) {
  deleteMeasureSet(input: $input) {
    id
    company {
      id
      name
      fullname
      address_street
      address_street_no
      address_zip
      address_city
      address_country
      responsible_name
      responsible_role
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    type
    label
    seq_nr
    description
    processes {
      nextToken
    }
    measures {
      nextToken
    }
    commentatory
    status
    createdAt
    updatedAt
  }
}
`;
export const createProcessMeasureSet = `mutation CreateProcessMeasureSet($input: CreateProcessMeasureSetInput!) {
  createProcessMeasureSet(input: $input) {
    id
    process {
      id
      text_header
      seq_nr
      status
      text_legal
      legal_basis
      text_problem
      damage_scenario
      risk_probability
      data_category
      victim_risk
      damage_rate
      dept_resp
      recipient_category
      delete_period
      assessment_necessary
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    measureSet {
      id
      type
      label
      seq_nr
      description
      commentatory
      status
      createdAt
      updatedAt
    }
    status
  }
}
`;
export const updateProcessMeasureSet = `mutation UpdateProcessMeasureSet($input: UpdateProcessMeasureSetInput!) {
  updateProcessMeasureSet(input: $input) {
    id
    process {
      id
      text_header
      seq_nr
      status
      text_legal
      legal_basis
      text_problem
      damage_scenario
      risk_probability
      data_category
      victim_risk
      damage_rate
      dept_resp
      recipient_category
      delete_period
      assessment_necessary
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    measureSet {
      id
      type
      label
      seq_nr
      description
      commentatory
      status
      createdAt
      updatedAt
    }
    status
  }
}
`;
export const deleteProcessMeasureSet = `mutation DeleteProcessMeasureSet($input: DeleteProcessMeasureSetInput!) {
  deleteProcessMeasureSet(input: $input) {
    id
    process {
      id
      text_header
      seq_nr
      status
      text_legal
      legal_basis
      text_problem
      damage_scenario
      risk_probability
      data_category
      victim_risk
      damage_rate
      dept_resp
      recipient_category
      delete_period
      assessment_necessary
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    measureSet {
      id
      type
      label
      seq_nr
      description
      commentatory
      status
      createdAt
      updatedAt
    }
    status
  }
}
`;
export const createProcess = `mutation CreateProcess($input: CreateProcessInput!) {
  createProcess(input: $input) {
    id
    company {
      id
      name
      fullname
      address_street
      address_street_no
      address_zip
      address_city
      address_country
      responsible_name
      responsible_role
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    comments {
      nextToken
    }
    text_header
    seq_nr
    status
    text_legal
    legal_basis
    text_problem
    damage_scenario
    risk_probability
    data_category
    victim_risk
    damage_rate
    dept_resp
    recipient_category
    delete_period
    assessment_necessary
    measureSets {
      nextToken
    }
    measures {
      nextToken
    }
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
export const updateProcess = `mutation UpdateProcess($input: UpdateProcessInput!) {
  updateProcess(input: $input) {
    id
    company {
      id
      name
      fullname
      address_street
      address_street_no
      address_zip
      address_city
      address_country
      responsible_name
      responsible_role
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    comments {
      nextToken
    }
    text_header
    seq_nr
    status
    text_legal
    legal_basis
    text_problem
    damage_scenario
    risk_probability
    data_category
    victim_risk
    damage_rate
    dept_resp
    recipient_category
    delete_period
    assessment_necessary
    measureSets {
      nextToken
    }
    measures {
      nextToken
    }
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
export const deleteProcess = `mutation DeleteProcess($input: DeleteProcessInput!) {
  deleteProcess(input: $input) {
    id
    company {
      id
      name
      fullname
      address_street
      address_street_no
      address_zip
      address_city
      address_country
      responsible_name
      responsible_role
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    comments {
      nextToken
    }
    text_header
    seq_nr
    status
    text_legal
    legal_basis
    text_problem
    damage_scenario
    risk_probability
    data_category
    victim_risk
    damage_rate
    dept_resp
    recipient_category
    delete_period
    assessment_necessary
    measureSets {
      nextToken
    }
    measures {
      nextToken
    }
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
export const createProcComment = `mutation CreateProcComment($input: CreateProcCommentInput!) {
  createProcComment(input: $input) {
    id
    process {
      id
      text_header
      seq_nr
      status
      text_legal
      legal_basis
      text_problem
      damage_scenario
      risk_probability
      data_category
      victim_risk
      damage_rate
      dept_resp
      recipient_category
      delete_period
      assessment_necessary
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    text
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
export const updateProcComment = `mutation UpdateProcComment($input: UpdateProcCommentInput!) {
  updateProcComment(input: $input) {
    id
    process {
      id
      text_header
      seq_nr
      status
      text_legal
      legal_basis
      text_problem
      damage_scenario
      risk_probability
      data_category
      victim_risk
      damage_rate
      dept_resp
      recipient_category
      delete_period
      assessment_necessary
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    text
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
export const deleteProcComment = `mutation DeleteProcComment($input: DeleteProcCommentInput!) {
  deleteProcComment(input: $input) {
    id
    process {
      id
      text_header
      seq_nr
      status
      text_legal
      legal_basis
      text_problem
      damage_scenario
      risk_probability
      data_category
      victim_risk
      damage_rate
      dept_resp
      recipient_category
      delete_period
      assessment_necessary
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    text
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
